import { ActionTree } from 'vuex'
import { CookieState, CookieCategoryStatus } from './types'
import { RootState } from '../types'
import config from 'config'
import VueCookie from 'vue-cookie'
import cookieCategories from '@/assets/cookies.json'

export const actions: ActionTree<CookieState, RootState> = {
  /**
  * Dispatch loadCookies action
  */
  loadCookies ({ commit }) {
    const optout = VueCookie.get(config.cookies.cookie_optout)
    commit('SET_OPTOUT', optout)
    for (const [key, category] of Object.entries(cookieCategories)) {
      category.checked = !optout ? true : !optout.includes(key)
      commit('SET_CATEGORY', { [key]: category })
    }
  },
  update ({ state, commit }, postMessageId = null) {
    if (state.categories) {
      // Get optout value from user selection
      const optout = Object.entries(state.categories)
        .filter(value => !value[1].checked)
        .map(value => value[0])
        .join('_') || 'none'
      commit('SET_OPTOUT', optout)
      if (optout !== state.optout && !postMessageId) {
        VueCookie.set(config.cookies.cookie_optout, state.optout)
      } else {
        window.parent.postMessage({ id: postMessageId, value: state.optout }, '*')
      }
    }
  },
  changeValues ({ commit }, cookieCategoryStatus: CookieCategoryStatus[]) {
    commit('UPDATE_CATEGORY_VALUE', cookieCategoryStatus)
  }
}
